var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Flex, Button, IconButton, Container, Stack, useMediaQuery } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
var links = [
    { link_name: 'home', url: '/' },
    { link_name: 'news', url: '/news' },
    { link_name: 'astronauts', url: '/astronauts' },
    { link_name: 'experimental', url: '/experimental' },
    { link_name: 'birthday', url: '/birthday' },
];
var NavLink = function (_a) {
    var children = _a.children, url = _a.url, mobile = _a.mobile;
    var history = useNavigate();
    return (_jsx(_Fragment, { children: !mobile ? (_jsx(Button, __assign({ as: "a", mx: 1, my: 5, w: "unset", minW: '5rem', colorScheme: 'orange', variant: "ghost", color: "white", textDecor: "none", textTransform: "capitalize", href: url, "aria-label": children, onClick: function (e) {
                e.preventDefault();
                history(url);
            } }, { children: children }))) : (_jsx(Button, __assign({ as: "a", w: "100%", variant: "ghost", colorScheme: 'orange', color: "white", textDecor: "none", textTransform: "capitalize", "aria-label": children, href: url, onClick: function (e) {
                e.preventDefault();
                history(url);
            } }, { children: children }))) }));
};
export default function Navbar() {
    var _a = useState('none'), display = _a[0], changeDisplay = _a[1];
    var mobile = useMediaQuery('(max-width: 768px)')[0];
    console.log(mobile);
    return (_jsx(_Fragment, { children: _jsx(Container, __assign({ display: "flex", justifyContent: 'flex-end', zIndex: "99", maxW: "99vw", w: "99vw", m: "0", p: "0", position: 'fixed', top: "0", right: '0' }, { children: _jsxs(Flex, __assign({ mr: '10px', mt: "10px" }, { children: [_jsxs(Flex, __assign({ align: "center" }, { children: [_jsx(Flex, __assign({ display: ['none', 'none', 'flex', 'flex'] }, { children: links.map(function (_a) {
                                    var link_name = _a.link_name, url = _a.url;
                                    return (_jsx(NavLink, __assign({ url: url, mobile: mobile }, { children: link_name }), url));
                                }) })), mobile ? (_jsx(IconButton, { "aria-label": "Open Menu", size: "lg", mt: "2", mr: '2', icon: _jsx(HamburgerIcon, {}), onClick: function () { return changeDisplay('flex'); }, display: ['flex', 'flex', 'none', 'none'] })) : (_jsx(_Fragment, {}))] })), mobile ? (_jsxs(Flex, __assign({ w: "100vw", display: display, zIndex: 20, h: "100vh", pos: "fixed", top: "0", left: "0e", overflowY: "auto", flexDir: "column" }, { children: [_jsx(Flex, __assign({ justify: "flex-end" }, { children: _jsx(IconButton, { mt: '2', mr: '2', "aria-label": "Open Menu", size: "lg", icon: _jsx(CloseIcon, {}), onClick: function () { return changeDisplay('none'); } }) })), _jsx(Stack, __assign({ align: 'center', spacing: "5" }, { children: links.map(function (_a) {
                                    var link_name = _a.link_name, url = _a.url;
                                    return (_jsx(NavLink, __assign({ url: url, mobile: mobile }, { children: link_name }), url));
                                }) }))] }))) : (_jsx(_Fragment, {}))] })) })) }));
}
